import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireSrc } from "/home/lkuklis/src/ea-sbc-squad-calculator/src/index.js";
var srcExports = requireSrc();
export { srcExports as __moduleExports };
export default srcExports.default;